import type { HTMLAttributes, ReactNode } from 'react'
import { cx } from '@/lib/cx'
import styles from './Eyebrow.module.css'

/** Props for {@link Eyebrow}. */
export interface EyebrowProps extends HTMLAttributes<HTMLElement> {
  /** The small iris mark before the label: a dot (default) or a short line. */
  mark?: 'dot' | 'line'
  /** Element to render. Default `'p'`. */
  as?: 'p' | 'span' | 'div'
  children: ReactNode
}

/**
 * Mono, uppercase label above a headline, e.g. "02 — How it works".
 *
 * @example <Eyebrow>{pipeline.eyebrow}</Eyebrow>
 */
export function Eyebrow({
  mark = 'dot',
  as: Tag = 'p',
  className,
  children,
  ...rest
}: EyebrowProps) {
  return (
    <Tag className={cx(styles.eyebrow, className)} {...rest}>
      <span className={cx(styles.mark, mark === 'line' && styles.line)} aria-hidden="true" />
      {children}
    </Tag>
  )
}
